module.exports = __webpack_public_path__ + "static/Coimbatore-69152ad6e7fe651adb40f2c5501365eb.png";